import type { IComponentDef } from '../types';

export const manifests = import.meta.glob('./*/manifest.ts', { eager: true });

export const LIBRARY: IComponentDef[] = Object.keys(manifests)
  .map(path => {
    const manifest = (manifests[path] as any).default;
    return manifest;
  })
  .filter(manifest => manifest.showInLibrary !== false);
